// extracted by mini-css-extract-plugin
export var attachment = "_q0-a";
export var emailContainer = "_q0-4";
export var emailContentPaddedContainer = "_q0-b";
export var emailHeader = "_q0-6";
export var emailIframe = "_q0-3";
export var emailInfoIcon = "_q0-9";
export var emailShortenedSummary = "_q0-e";
export var infoDropdown = "_q0-0";
export var infoRowBoundedContent = "_q0-d";
export var internal = "_q0-5";
export var merchant = "_q0-8";
export var messageInputContainer = "_q0-h";
export var normal = "_q0-7";
export var replyCard = "_q0-f";
export var subtleButton = "_q0-1";
export var subtleButtonIconContainer = "_q0-2";
export var toggleViewRepliesButton = "_q0-c";
export var wrappingText = "_q0-g";